import StepSection from './StepSection';
import { Grid as G, TextWithIcon } from '../../../components';
import * as S from './styles';
import { stepTypes } from '../../../constants/data-types';
import formatSectionErrors from '../../../helpers/formatSectionErrors';

const newItem = {
  title: '',
  description: [],
  thisCanInclude: [],
  tips: [],
};

const createNewSection = (index) => {
  return {
    title: `Section ${index + 1}`,
    items: [{ ...newItem }],
  };
};

const QuestionStepSections = ({
  state,
  setState,
  validationErrs,
  ...props
}) => {
  const { sections } = state;

  const handleTitleChange = (sectionIndex, newValue) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex] = {
      ...updatedSections[sectionIndex],
      title: newValue,
    };
    setState({ sections: updatedSections });
  };

  const handleItemChange = (sectionIndex, itemIndex, newValue) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex] = {
      ...updatedSections[sectionIndex],
      items: updatedSections[sectionIndex].items.map((item, i) =>
        i === itemIndex ? newValue : item
      ),
    };
    setState({ sections: updatedSections });
  };

  const handleItemRemove = (sectionIndex, itemIndex) => {
    const updatedSections = [...sections];
    if (updatedSections[sectionIndex].items.length === 1) {
      updatedSections.splice(sectionIndex, 1);
    } else {
      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        items: updatedSections[sectionIndex].items.filter(
          (_, i) => i !== itemIndex
        ),
      };
    }
    setState({ sections: updatedSections });
  };

  const handleItemAdd = (sectionIndex) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex] = {
      ...updatedSections[sectionIndex],
      items: [...updatedSections[sectionIndex].items, { ...newItem }],
    };
    setState({ sections: updatedSections });
  };

  const handleAddSection = (sectionsLength) => {
    const newSection = createNewSection(sectionsLength);
    setState({
      sections: [...sections, { ...newSection }],
    });
  };

  const handleRemoveSection = (sectionIndex) => {
    setState({
      sections: sections.filter((_, i) => i !== sectionIndex),
    });
  };

  return (
    <>
      {sections.map((section, sectionIndex) => (
        <div key={`SECTION_CONTAINER_${sectionIndex}`}>
          <G.Row mt="8">
            <G.Col w={[4, 12, 12]} mt="2">
              <StepSection
                key={`QUESTION_SECTION_${sectionIndex}`}
                sectionItems={section.items || []}
                sectionTitle={section.title}
                stepType={stepTypes.QUESTION}
                sectionIndex={sectionIndex}
                handleTitleChange={(newValue) =>
                  handleTitleChange(sectionIndex, newValue)
                }
                handleItemChange={(itemIndex, newValue) =>
                  handleItemChange(sectionIndex, itemIndex, newValue)
                }
                handleItemRemove={(itemIndex) =>
                  handleItemRemove(sectionIndex, itemIndex)
                }
                handleItemAdd={() => handleItemAdd(sectionIndex)}
                errors={formatSectionErrors(
                  sectionIndex,
                  validationErrs,
                  stepTypes.QUESTION
                )}
                hideTitle={true}
                {...props}
              />
              {sections.length > 1 && (
                <S.SectionFooter>
                  <TextWithIcon
                    text="Remove section"
                    isButton
                    color="black"
                    handleClick={() => handleRemoveSection(sectionIndex)}
                    iconProps={{
                      icon: 'close',
                      color: 'primaryMain',
                    }}
                  />
                </S.SectionFooter>
              )}
            </G.Col>
          </G.Row>
        </div>
      ))}
      <G.Row mt="6">
        <G.Col w={[4, 6, 6]}>
          <TextWithIcon
            text="Add new section"
            isButton
            mt="4"
            color="neutralMain"
            handleClick={() => handleAddSection(sections.length)}
            weight="semi"
            iconProps={{
              icon: 'add',
              color: 'primaryMain',
              pointer: true,
            }}
          />
        </G.Col>
      </G.Row>
    </>
  );
};

export default QuestionStepSections;
